import { gql } from '@apollo/client'

export const GET_BRAND_DISPLAY_AUDITS = gql`
  query GetBrandDisplayAudits($input: DXOExecutionForZonePathInput!) {
    brandDisplayAudits(input: $input) {
      hasMore
      count
      results {
        keyAccount
        displayAuditImageUrl
        id
        sovi
        county
        state
        date
        allImages
      }
    }
  }
`
